module.exports = __webpack_public_path__ + "static/media/logoFoodChain2.58d623fa.svg";